import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import EquitableConstruction from "@/pages/EquitableConstruction";
import Residential from "@/pages/Residential";
import Commercial from "@/pages/Commercial";
import Projects from "@/pages/Projects";
import Process from "@/pages/Process";
import About from "@/pages/About";
import Financing from "@/pages/Financing";
import Contact from "@/pages/Contact";
import AdminLeads from "@/pages/AdminLeads";
import Legal from "@/pages/Legal";
import NotFound from "@/pages/NotFound";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09 });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/equitable-construction" element={<EquitableConstruction />} />
            <Route path="/residential-construction" element={<Residential />} />
            <Route path="/commercial-construction" element={<Commercial />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/our-process" element={<Process />} />
            <Route path="/about" element={<About />} />
            <Route path="/financing" element={<Financing />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<Legal kind="privacy" />} />
            <Route path="/terms" element={<Legal kind="terms" />} />
            <Route path="/admin/leads" element={<AdminLeads />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
        <Toaster
          position="top-center"
          theme="dark"
          toastOptions={{ style: { background: "#14161B", border: "1px solid #282C35", color: "#fff", borderRadius: 0 } }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
